export default async function filterSessionsByOIPStatus(
  sessions,
  username,
  colleagueId,
  { getOipStudents, fetchSession },
) {
  try {
    const studentData = await getOipStudents(colleagueId);
    // If the sessions already have details, use them directly
    if (sessions[0]?.details) {
      return sessions.filter((session) => {
        const normalizedUsername = username?.toLowerCase();
        const whitelist = session.details?.postDeadlineApplicantWhitelist || [];

        if (!studentData) {
          return !session.sessionType.toLowerCase().includes('oip')
            || whitelist.includes(normalizedUsername);
        }
        return session.sessionType.toLowerCase().includes('oip')
          || whitelist.includes(normalizedUsername);
      });
    }

    // Otherwise, fetch details
    const sessionPromises = sessions.map(async (session) => {
      const sessionId = session.value || session.sessionId;
      const details = await fetchSession(sessionId);
      return {
        session,
        details,
      };
    });

    const sessionsWithDetails = await Promise.all(sessionPromises);

    return sessionsWithDetails
      .filter(({ details }) => {
        const normalizedUsername = username?.toLowerCase();
        const whitelist = details?.postDeadlineApplicantWhitelist || [];

        if (!studentData) {
          return !details.sessionType.toLowerCase().includes('oip')
            || whitelist.includes(normalizedUsername);
        }
        return details.sessionType.toLowerCase().includes('oip')
          || whitelist.includes(normalizedUsername);
      })
      .map(({ session }) => session);
  } catch (error) {
    console.error('Error in filterSessionsByOIPStatus:', error);
    return sessions;
  }
}
